import { Card, Stack, Typography } from "@mui/material";
import { useTranslations } from "hooks/useTranslations";
import React from "react";

import { sharedStyles } from "./cardStyles";
import { IBookingPassenger } from "@thekilroygroup/shared-ui";
import { format, parseISO } from "date-fns";
interface IProps {
  passenger: IBookingPassenger;
}
export const PassengerCard = (props: IProps) => {
  const {
    translations: {
      confirmationPage: { travelerDetails },
    },
  } = useTranslations();

  const { passenger } = props;
  const formattedDate = format(parseISO(passenger.dateOfBirth), "dd. MMM yyyy");

  return (
    <>
      <Card sx={sharedStyles.card}>
        <Typography sx={sharedStyles.cardHeader} variant="h5" color="primary">
          {travelerDetails.title}
        </Typography>

        <Stack sx={sharedStyles.wrapper}>
          <Typography sx={sharedStyles.label}>
            {travelerDetails.name}
          </Typography>
          <Typography sx={sharedStyles.value}>
            {passenger.title} {passenger.firstName} {passenger.middleName}{" "}
            {passenger.lastName}
          </Typography>
        </Stack>
        <Stack sx={sharedStyles.wrapper}>
          <Typography sx={sharedStyles.label}>
            {travelerDetails.birthDate}
          </Typography>
          <Typography sx={sharedStyles.value}>{formattedDate}</Typography>
        </Stack>
        <Stack sx={sharedStyles.wrapper}>
          <Typography sx={sharedStyles.label}>
            {travelerDetails.ticketName}
          </Typography>
          <Typography sx={sharedStyles.value}>
            {passenger.nameOnTicket}
          </Typography>
        </Stack>
      </Card>
    </>
  );
};
